// src/services/presupuestoService.js
import api from "./api";

export const getPresupuestos = async () => {
  const res = await api.get("/presupuestos");
  return res.data;
};

export const createPresupuesto = async (presupuesto) => {
  const res = await api.post("/presupuestos", presupuesto);
  return res.data;
};


export const deletePresupuesto = async (id) => {
    try {
        
        await api.delete(`/presupuestos/${id}`);
    } catch (error) {
        console.error("Error al eliminar presupuesto:", error);
        throw error;
    }
};